import axios from "axios";
import orderBy from "lodash/orderBy";

export default {
  async getCategories() {
    const categories = await axios({
      url: '/api/category',
    }).then(r => r.data);
    
    return orderBy(categories, ['order'], ['asc']);
  },
  async getCategory(id) {
    return await axios({
      url: '/api/category/' + id,
    }).then(r => r.data);
  },
  async addCategory(data) {
    return await axios({
      url: '/api/category',
      method: 'post',
      data,
    }).then(r => r.data);
  },
  async updateCategory(id, data) {
    return await axios({
      url: '/api/category/' + id,
      method: 'put',
      data,
    }).then(r => r.data);
  },
  async deleteCategory(id) {
    return await axios({
      url: '/api/category/' + id,
      method: 'delete',
    }).then(r => r.data);
  }

};
